import { makeStyles } from "@material-ui/core/styles";

/**
 * スタイルHook.
 *
 * @type {object}
 */
const useStyles = makeStyles((theme) => ({
  flexStart: {
    display: "flex",
    justifyContent: "flex-start",
  },
  marginLeftAuto: {
    marginLeft: "auto",
  },
  card: {
    padding: theme.spacing(2, 0, 0),
  },
  cardContent: {
    padding: theme.spacing(1, 4),
  },
  tableContainerSmall: {
    maxHeight: 300,
  },
  tableHeader: {
    fontWeight: "bold",
  },
  fileNameTableCell: {
    width: "50%",
  },
  fileLastModifiedTableCell: {},
  fileSizeTableCell: {
    width: "15%",
  },
  fileNameTableCellSmall: {
    width: "70%",
  },
  fileSizeTableCellSmall: {},
  iconTableCell: {
    width: 44,
    padding: theme.spacing(0),
  },
  machineNameTableCell: {
    width: "15%",
  },
  machineTableCell: {
    width: "12%",
  },
  registerTimestampTableCell: {
    width: "25%",
  },
  registerFileNameTableCell: {
    width: "50%",
  },
  registerResultTableCell: {
    width: "25%",
  },
  canceliconButton: {
    padding: "4px",
  },
  fileNameIcon: {
    display: "flex",
    alignItems: "center",
  },
  fileNameText: {
    display: "flex",
    alignItems: "center",
    marginLeft: theme.spacing(1),
  },
  machineNameText: {
    display: "flex",
    alignItems: "center",
    marginLeft: theme.spacing(1),
  },
  dialogContent: {
    padding: theme.spacing(2, 5),
  },
  dialogActions: {
    padding: theme.spacing(3, 2, 2),
  },
  dragAndDropPaper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(5, 2),
    borderWidth: 2,
    borderRadius: 2,
    borderColor: "#eeeeee",
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "#bdbdbd",
    outline: "none",
  },
  breadcrumbs: {
    "& ol": {
      alignItems: "flex-end",
    },
  },
  dialogTextFieldFolderName: {},
  dialogFolderNameError: {
    padding: theme.spacing(1, 1),
  },
  wordBreak: {
    wordBreak: "break-word",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 200,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  registerButton: {
    width: "100%",
    height: 80,
  },
  reportGrid: {
    width: "100%",
  },
  reportGridItemLarge: {
    width: 630,
  },
  reportGridItemSmall: {
    width: 210,
  },
  reportInputTextField: {
    width: "100%",
  },
  reportInputButton: {
    width: "100%",
  },
  reportDateTableContainer: {
    margin: theme.spacing(0, 0, 1, 0),
    padding: theme.spacing(0),
    width: "100%",
    height: 120 + 3,
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "black",
  },
  reportDateTable: {
    margin: theme.spacing(0),
    padding: theme.spacing(0),
    width: "100%",
  },
  reportDateTableHead: {
    "& > tr > th": {
      borderTopWidth: "0px",
      borderLeftWidth: "0px",
      borderRightWidth: "1px",
      borderBottomWidth: "1px",
      borderStyle: "solid",
      borderColor: "black",
      fontWeight: "bold",
      color: "white",
      backgroundColor: "#505050",
    },
  },
  reportDateTableBody: {
    "& > tr > td": {
      borderTopWidth: "1px",
      borderLeftWidth: "0px",
      borderRightWidth: "1px",
      borderBottomWidth: "0px",
      borderStyle: "solid",
      borderColor: "black",
    },
    "& > tr:first-child > td": {
      borderTopWidth: "0px",
    },
    "& > tr:only-child > td": {
      borderBottomWidth: "1px",
    },
    "& > tr:only-child > td:last-child": {
      borderRightWidth: "0px",
    },
    "& > tr:first-child:nth-last-child(2),  tr:first-child:nth-last-child(2) ~ tr > td:last-child, ": {
      borderRightWidth: "0px",
    },
  },
  reportDateTableRow: {
    margin: theme.spacing(0),
    padding: theme.spacing(0),
    height: 40,
  },
  reportDateTableCell: {
    margin: theme.spacing(0),
    padding: theme.spacing(1),
    whiteSpace: "pre-line",
    verticalAlign: "top",
  },
  reportDateTableYearCell: {
    fontWeight: "bold",
    backgroundColor: "#D0D0D0",
  },
  reportDateTableDateCell: {
    width: "4.7%",
  },
  reportInputTableContainer: {
    margin: theme.spacing(0),
    padding: theme.spacing(0),
    width: "100%",
  },
  reportInputTable: {
    margin: theme.spacing(0),
    padding: theme.spacing(1),
    width: "100%",
    "& .MuiTableCell-sizeSmall": {
      padding: theme.spacing(1),
    },
  },
  reportInputTableHead: {
    "& > tr > th": {
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "black",
      fontWeight: "bold",
    },
  },
  reportInputTableBody: {
    "& > tr > td": {
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "black",
    },
  },
  reportInputTableRow: {
    height: 50,
  },
  reportInputTableCell: {
    whiteSpace: "pre-line",
    verticalAlign: "top",
  },
  reportInputTableColumnNumber: {
    width: "3%",
  },
  reportInputTableColumnCategory: {
    width: "10%",
  },
  reportInputTableColumnItem: {
    width: "10%",
  },
  reportInputTableColumnValue: {
    width: "8%",
  },
  reportInputTableColumnJudge: {
    width: "6%",
    fontWeight: "bold",
  },
  reportInputTableColumnNote: {
    width: "18%",
  },
  reportInputTableColumnExplanation: {
    width: "17%",
  },
  reportInputTableForm: {
    margin: theme.spacing(0),
    padding: theme.spacing(0),
    width: "100%",
    height: "100%",
  },
  reportInputTableInput: {
    margin: theme.spacing(0),
    padding: theme.spacing(0),
    width: "100%",
    height: "100%",
    fontSize: "0.875rem",
    alignItems: "flex-start",
    borderBottom: "0px solid red !important",
    "&:hover": {
      borderBottom: "0px solid rgba(0,0,0,0)",
    },
  },
  reportInputTableSelect: {
    fontWeight: "bold",
  },

  reportInputSubTable: {
    margin: theme.spacing(6, 0, 0, 0),
    padding: theme.spacing(1),
    width: "100%",
    "& .MuiTableCell-sizeSmall": {
      padding: theme.spacing(1),
    },
  },
  reportInputSubTableHead: {
    "& > tr > th": {
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "black",
      fontWeight: "bold",
    },
  },
  reportInputSubTableBody: {
    "& > tr > td": {
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "black",
    },
  },
  reportInputSubTableCell: {
    whiteSpace: "pre-line",
    verticalAlign: "middle",
  },
  referenceLineForm: {
    display: "flex",
    alignItems: "center",
  },
  referenceLineFormInput: {
    width: "100%",
    "& .Mui-disabled": {
      backgroundColor: "#DDDDDD",
    },
    "& .Mui-error": {
      backgroundColor: "#FFCCCC",
    },
  },
  registerTable: {
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "black",
  },
  registerTableHead: {
    "& > tr > th": {
      margin: theme.spacing(0),
      padding: theme.spacing(1),
      borderTopWidth: "0px",
      borderLeftWidth: "0px",
      borderRightWidth: "1px",
      borderBottomWidth: "1px",
      borderStyle: "solid",
      borderColor: "black",
      fontWeight: "bold",
      color: "white",
      backgroundColor: "#505050",
    },
  },
  registerTableBody: {
    "& > tr > td": {
      margin: theme.spacing(0),
      padding: theme.spacing(1),
      borderTopWidth: "1px",
      borderLeftWidth: "0px",
      borderRightWidth: "1px",
      borderBottomWidth: "0px",
      borderStyle: "solid",
      borderColor: "black",
    },
    "& > tr:first-child > td": {
      borderTopWidth: "0px",
    },
    "& > tr:only-child > td": {
      borderBottomWidth: "1px",
    },
    "& > tr:only-child > td:last-child": {
      borderRightWidth: "0px",
    },
    "& > tr:first-child:nth-last-child(2),  tr:first-child:nth-last-child(2) ~ tr > td:last-child, ": {
      borderRightWidth: "0px",
    },
  },
}));

export default useStyles;
